import React from "react";
import ReactDOM from "react-dom";
import GuideToolbar from "./GuideToolbar";

// Import your existing left-panel paint controls component here:
// (use the *real* path/name from your codebase)

// ^^^ Replace with your actual file/component that renders the color swatch,
// brush size slider, symmetry toggle, etc. The goal is to reuse it verbatim.

export default function OverlayPaintControlsPortal({ container }) {
  if (!container) return null;
  return ReactDOM.createPortal(
   
    <GuideToolbar variant="overlay" />,
    container
  );
}